<template>
    <button type="button" class="btn btn-cta uc trigger-form" @click="toggleLeadForm">Get Started</button>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: 'HomeLeadFormButton',
    methods: mapActions(["toggleLeadForm"])
}
</script>

<style>

</style>
